import { FC, useCallback } from "react";
import { Box, Link, Typography } from "@mui/material";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import {
  callUsContact,
  callUsSubTitle,
  callUsTimings,
  callUsTitle,
  DEVICE_TYPE,
} from "../../../utils/constants";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import "./CallUsPopUp.scss";
import useCmsPageVariables from "../../../hooks/useCmsPageVariables";
import usePermissionWithPopup from "../../../hooks/useAppPermisssion";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import { Colors } from "../../../styles/constant";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

interface Props {
  open: boolean;
  handleOpen: Function;
}

const CallUsPopUp: FC<Props> = ({ open, handleOpen }) => {
  const deviceType = useDeviceDetection();
  const cmsContact = useCmsPageVariables("call-us");
  const { checkPermissions, renderPopUp } = usePermissionWithPopup();
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const handleClosePopup = useCallback(() => {
    handleOpen(false);
  }, [handleOpen]);

  let title = cmsContact?.attributes?.title || callUsTitle;
  let subTitle = cmsContact?.attributes?.text || callUsSubTitle;
  let contactNumber = cmsContact?.attributes?.url || callUsContact;
  let callUsTiming = cmsContact?.attributes?.richText || callUsTimings;

  const handleCallClick = () => {
    // const { allGranted, unGrantedPermissions } = checkPermissions(["call"]);
    // console.log(unGrantedPermissions);
    // if (!allGranted && !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
    //   return;
    // }
    window.location.href = `tel:${contactNumber}`;
  };

  const renderSteps = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="1rem"
        textAlign="center"
      >
        <Typography
          variant="h5"
          color={Colors.darkCharcoal}
          letterSpacing=".0938rem"
        >
          {title}
        </Typography>
        <Typography variant="h5" fontWeight="400" color={Colors.darkCharcoal}>
          {subTitle}
        </Typography>
        {deviceType === DEVICE_TYPE.WEB ? (
          <Typography variant="h5" fontWeight="400" color="#0000EEEE">
            {contactNumber}
          </Typography>
        ) : (
          <Typography>
            <Link
              variant="h5"
              fontWeight="400"
              onClick={handleCallClick}
              color="#0000EEEE"
              underline="always"
              style={{ cursor: "pointer" }}
              aria-label={`Call ${contactNumber}`}
            >
              {contactNumber}
            </Link>
          </Typography>
        )}
        {renderPopUp()}
        <Typography variant="h5" fontWeight="400" color={Colors.darkCharcoal}>
          {callUsTiming}
        </Typography>
      </Box>
    );
  };
  return (
    <CustomPopup
      open={open}
      handleOpen={handleClosePopup}
      btnLabel={"Go back"}
      className="add-callus-popup"
      btnStartIcon={<ChevronLeftIcon fontSize="small" />}
    >
      <Box className="add-callus-popup-content">{renderSteps()}</Box>
    </CustomPopup>
  );
};
export default CallUsPopUp;
